module.exports = __webpack_public_path__ + "static/receptum-f6c3907a412c39aaa1b7ded6884a2ada.svg";